var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-form-item',{ref:"cFormItem",attrs:{"formItems":_vm.formItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }